export const isImage = (attachment) => {
  return attachment && attachment.mediaType && attachment.mediaType.startsWith('image')
};

export const isSvgImage = (attachment) => {
  return attachment && attachment.mediaType && attachment.mediaType.startsWith('image') && attachment.mediaType.includes('svg')
};

export const isNonSvgImage = (attachment) => {
  return attachment && attachment.mediaType && attachment.mediaType.startsWith('image') && !attachment.mediaType.includes('svg')
};

export const isVideo = (attachment) => {
  return attachment && attachment.mediaType && attachment.mediaType.startsWith('video')
};

export const isMediaTypeVideo = mediaType => mediaType.startsWith('video');
export const isMediaTypeImage = mediaType => mediaType.startsWith('image');

const VIDEO_MP4 = 'video/mp4';
const SUPPORTED_VIDEO_STREAM_TYPES = [VIDEO_MP4];

export const isSupportedVideoStreamType = mediaType => {
  return SUPPORTED_VIDEO_STREAM_TYPES.includes(mediaType);
};